export function sortBannerAppearance(photo) {
	if (!photo.appearance || !photo.appearance.items) {
		return []
	}

	const orientationRules = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]

	return photo.appearance.items.sort((a, b) => {
		return orientationRules.indexOf(a.orientation) - orientationRules.indexOf(b.orientation)
	})
}

export function sortBannerInterior(photo) {
	if (!photo.interior || !photo.interior.items) {
		return []
	}

	const orientationRules = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]

	return photo.interior.items.sort((a, b) => {
		return orientationRules.indexOf(a.orientation) - orientationRules.indexOf(b.orientation)
	})
}

/**
 * 车辆实拍这部分的排序规则和banner是不一样的
 * @param interiorItems
 */

export function sortAlbumDouble(doubleItems) {
	if (!doubleItems || !doubleItems.length) {
		return []
	}
	const items = doubleItems.filter(Boolean)
	items.forEach((item, index) => (item.bannerIdx = index))
	return items
}

export function sortAlbumInterior(interiorItems) {
	if (!interiorItems || !interiorItems.length) {
		return []
	}

	const orientationRules = [5, 1, 4]

	// const items = orientationRules
	// 	.map((code, index) => {
	// 		return interiorItems.find(item => item.orientation === code)
	// 	})
	// 	.filter(Boolean)
	// items.forEach((item, index) => (item.bannerIdx = index))

	// return items

	return interiorItems
		.map((item, index) => {
			if (orientationRules.includes(item.orientation)) {
				item.bannerIdx = index
			}
			return item
		})
		.filter(item => item.bannerIdx !== undefined)
		.sort(
			(a, b) =>
				orientationRules.findIndex(code => a.orientation === code) -
				orientationRules.findIndex(code => b.orientation === code)
		)
}
export function sortAlbumAppearance(appearanceItems) {
	if (!appearanceItems || !appearanceItems.length) {
		return []
	}

	const orientationRules = [1, 9, 6]

	// const items = orientationRules
	// 	.map(code => {
	// 		return appearanceItems.find(item => item.orientation === code)
	// 	})
	// 	.filter(Boolean)

	// items.forEach((item, index) => (item.bannerIdx = index))
	// return items

	return appearanceItems
		.map((item, index) => {
			if (orientationRules.includes(item.orientation)) {
				item.bannerIdx = index
			}
			return item
		})
		.filter(item => item.bannerIdx !== undefined)
		.sort(
			(a, b) =>
				orientationRules.findIndex(code => a.orientation === code) -
				orientationRules.findIndex(code => b.orientation === code)
		)
}
